import Axios from 'axios'
import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import config from '../../Shared/config'
import BDGrid from './BackdoorCommonComponents/BDGrid'
import BDHeader from './BackdoorCommonComponents/BDHeader'
import BDNew from './BackdoorCommonComponents/BDNew'
import GenericMessages from './BackdoorCommonComponents/GenericMessages'
import PageModes from './BackdoorCommonComponents/PageModes'

export default class DevContent extends Component {

    getModeFromPathname = (pathname) => {
        if (!pathname) {
            return ''
        }

        if (pathname.includes('/new'))
            return PageModes.NEW
        else if (pathname.includes('/view'))
            return PageModes.VIEW
        else if (pathname.includes('/edit'))
            return PageModes.EDIT
        else if (pathname.includes('/delete'))
            return PageModes.DELETE
        else
            return PageModes.GRID
    }

    onClickSave = () => {
        let { formData, files } = this.newPage.state

        if (!this.props.useGenericSave) {
            this.props.onClickSave(formData, files, () => {
                this.props.history.push(this.props.to)
            })
        } else {
            this.genericSave(formData)
        }
    }

    genericSave = (formData) => {
        const url = `${config.apiUrl}/${this.props.routeId}/add`;
        Axios.post(url, formData).then(res => {
            if (res.data) {
                alert(res.data.message)
                if (!res.data.error) {
                    this.props.history.push(this.props.to)
                }
            } else {
                alert(GenericMessages.noResponseFromServer)
            }
        }).catch(err => {
            console.error(err)
            alert(GenericMessages.someErrorOccured)
        })
    }

    onClickDelete = async (id) => {
        const url = `${config.apiUrl}/${this.props.routeId}/delete?id=${id}`;
        return Axios.get(url).then(res => {
            if (res.data) {
                alert(res.data.message)
                return true
            } else {
                alert(GenericMessages.noResponseFromServer)
                return false
            }
        }).catch(err => {
            console.error(err)
            alert(GenericMessages.someErrorOccured)
            return false
        })
    }

    onClickReset = () => {
        let accepted = false
        accepted = window.confirm('This operation will reset all the data of the form. Are you sure you want to continue?')
        if (accepted) {
            this.newPage.resetForm()
        }
    }

    render() {
        const MODE = this.getModeFromPathname(this.props.location?.pathname)

        return (
            <div className='devmain__container'>
                <BDHeader
                    {...this.props}
                    mode={MODE}
                    onClickSave={this.onClickSave}
                    onClickReset={this.onClickReset}
                />

                <Switch>
                    <Route path={this.props.to} exact render={(props) => <BDGrid {...this.props} onClickDelete={this.onClickDelete} />} />
                    <Route path={`${this.props.to}/new`} exact render={(props) => <BDNew ref={e => this.newPage = e} {...this.props} />} />
                </Switch>

            </div>
        )
    }
}
